import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";

const theme: IChannelTheme = {};

export default {
  configs: {
    pages: {
      Index: {
        banners: {
          list: [
            {
              img: "https://uploads.ytripos.com/uploaded/FvbGQ27nMEsgvNY5v1U_GWh52Umh/c553b7cc606dfee498bfbbe8f13f12e6.jpg"
            }
          ]
        }
      }
    }
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
